import moment from 'moment';
import LanguageDetector from 'i18next-browser-languagedetector';
import { isEmpty } from 'lodash';
import apple from '../../../assets/icons/Apple_logo.svg';
import android from '../../../assets/icons/android.svg';
import paypal from '../../../assets/icons/paypal.svg';
import card from '../../../assets/icons/card.svg';
//Tr
import i18n from '../../../i18n';
import { MONTH_NAMES } from '../../TipPublish/utils/buildCustomDate';

export const responsiveConfig = {
  mobile: {
    breakpoint: { max: 7000, min: 0 },
    items: 1,
  },
};
const lang = i18n.use(LanguageDetector).language;
export const getCountryIcon = async (key) => {
  if (key && !!key.length && key !== 'OT') {
    return await import(
      `../../../assets/icons/countries/${key.toLowerCase()}.svg`
    ).then((image) => image.default);
  } else {
    return await import(`../../../assets/icons/countries/generic.svg`).then(
      (image) => image.default,
    );
  }
};
export const periodFilterValues = [
  {
    key: 'CURRENT_MONTH',
    label: i18n.t('CURRENT_MONTH'),
  },
  {
    key: 'LAST_MONTH',
    label: i18n.t('LAST_MONTH'),
  },
  {
    key: 'LAST_3_MONTHS',
    label: i18n.t('LAST_3_MONTHS'),
  },
  {
    key: 'LAST_6_MONTHS',
    label: i18n.t('LAST_6_MONTHS'),
  },
  {
    key: 'LAST_12_MONTHS',
    label: i18n.t('LAST_12_MONTHS'),
  },
  {
    key: 'CURRENT_YEAR',
    label: i18n.t('CURRENT_YEAR'),
  },
  {
    key: 'CUSTOM',
    label: i18n.t('CUSTOM_PERIOD'),
  },
];
export const getSinceDate = (periodFilter, t) => {
  const formatDate = (date) => {
    let formattedDate;
    if (lang === 'en') {
      formattedDate = date.format('MMMM Do YYYY');
    } else {
      const month = t(date.format('MMMM'));
      formattedDate = date.format(`D [de] [${month}] [de] YYYY`);
    }
    return formattedDate;
  };

  switch (periodFilter) {
    case 'HISTORIC':
      return t('HISTORIC_info');
    case 'CURRENT_DAY':
      return formatDate(moment());
    case 'CURRENT_MONTH':
      return `${formatDate(moment().startOf('month'))} - ${formatDate(
        moment().endOf('month'),
      )}`;
    
    case 'LAST_MONTH':
      return `${formatDate(
        moment().subtract(1, 'months').startOf('month'),
      )} - ${formatDate(moment().subtract(1, 'months').endOf('month'))}`;

    case 'LAST_3_MONTHS':
      return `${formatDate(
        moment().subtract(3, 'months').date(1),
      )} - ${formatDate(moment().endOf('month'))}`;
    
    case 'LAST_6_MONTHS':
      return `${formatDate(
        moment().subtract(6, 'months').date(1),
      )} - ${formatDate(moment().endOf('month'))}`;

    case 'LAST_12_MONTHS':
      return `${formatDate(
        moment().subtract(12, 'months').date(1),
      )} - ${formatDate(moment().endOf('month'))}`;

    case 'CURRENT_YEAR':
      return `${formatDate(
        moment().startOf('year'),
      )} - ${formatDate(moment())}`;

    default:
      return periodFilter;
  }
};

export const getItemName = (key, metadata, t) => {
  switch (key) {
    case 'TIP_SALE':
      return `${t('tip')} · ${
        metadata.pick && !!metadata.pick.length
          ? metadata.pick
          : t(metadata.tip_type)
      }`;
    case 'SALES_INCOME':
      return `${t('sales_income_in')} - ${t(
        MONTH_NAMES[parseInt(metadata.month) - 1],
      )} (${100 - metadata.tipster_percentage}${t('commission_percentage')})`;
    case 'TIP_SALE_REFUND':
      return `${t('refund')} ${t('tip')} · ${
        metadata.pick && !!metadata.pick.length
          ? metadata.pick
          : t(metadata.tip_type)
      }`;
    case 'DISPUTES_REFUND':
      return `${t('disputes_refund')}`;
    case 'PREMIUM_SALE':
    case 'TIER_PREMIUM_SALE':
      return `Premium · ${t(metadata.plan_code)}`;
    case 'PREMIUM_SALE_REFUND':
    case 'TIER_PREMIUM_SALE_REFUND':
    case 'PREMIUM_FRAUD':
      return `${t('refund')} Premium · ${t(metadata.plan_code)}`;
    case 'PRODUCT_SALE_REFUND':
      return `${t('refund')} ${t('product')} · ${t(metadata.product_name)} ${t(
        metadata.product_description,
      )}`;
    case 'CHALLENGE_SHARE_RECEIVED':
    case 'CHALLENGE_SHARE_PAID':
      return `${t('transaction_challenge_share')} · ${metadata.concept}`;
    case 'PRODUCT_SALE':
      return `${t('product')} · ${t(metadata.product_name)} ${t(
        metadata.product_description,
      )}`;
    case 'REFERRAL_PAID':
    case 'REFERRAL_RECEIVED':
      return `${t('referral')} · ${metadata.tipster_name}`;
    case 'INCOME':
      return `${t('income')} · ${metadata.concept}`;
    case 'TRANSFER_RECEIVED':
      return `${t('transfer')} · ${metadata.orderer_tipster_name}`;
    case 'TRANSFER_PAID':
      return `${t('transfer')} · ${metadata.receiver_tipster_name}`;
    case 'PAYOUT':
      if (metadata.concept === 'COMISSIONS' || metadata.concept === 'PENDING COMISSIONS') {
        return 'Retirada de saldo';
      }
      // Para cualquier otro concepto, mostrar el concepto tal cual
      return metadata.concept;
    case 'TIP_COUPON_SALE':
      return `${t('tip')} · Stake ${metadata.stake}`;
    case 'TIP_COUPON_SALE_REFUND':
      return `${t('refund')} ${t('tip')} · Stake ${metadata.stake}`;
    default:
      return t(key);
  }
};

export const getStoreIcon = (store) => {
  switch (store) {
    case 'STRIPE':
      return card;
    case 'PAYPAL':
      return paypal;
    case 'APPLE':
      return apple;
    case 'ANDROID':
      return android;
    default:
      return '';
  }
};

export const getColumnName = (date, periodFilter, t) => {
  switch (periodFilter.key) {
    case 'HISTORIC':
      // Format: "Jan", "Feb", etc. and translate with _short suffix
      const monthShort = moment(date).locale('en').format('MMM');
      return t(`${monthShort}_short`);
    case 'CURRENT_DAY':
      return moment(date).format('DD/MM/YY');
    case 'CURRENT_MONTH':
      return moment(date).format('DD');
    case 'LAST_3_MONTHS':
      return moment(date).format('MMMM');

    case 'LAST_12_MONTHS':
      // Format: "Jan", "Feb", etc. and translate with _short suffix
      const month12 = moment(date).locale('en').format('MMM');
      return t(`${month12}_short`);

    default:
      // Format: "Jan", "Feb", etc. and translate with _short suffix
      const monthDefault = moment(date).locale('en').format('MMM');
      return t(`${monthDefault}_short`);
  }
};

export const formatNumber = (amount, decimals, hideZero = true) => {
  const addSeparators = (num) =>
    num
      .toString()
      .replace('.', ',') // replace decimal point character with ,
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
  let formatted;
  if (amount === 0) {
    if (hideZero) {
      return '';
    } else return amount;
  } else {
    if (!amount) {
      return '';
    }
    formatted = amount / Math.pow(10, decimals);
    if (formatted % 1 === 0) {
      return addSeparators(formatted);
    } else {
      return addSeparators(formatted.toFixed(2));
    }
  }
};

export const amountFloatFormatter = (string) => {
  // Detectar si usa formato europeo (coma decimal) o americano (punto decimal)
  // Formato europeo: 1.234,56 o 1234,56
  // Formato americano: 1,234.56 o 1234.56
  
  const hasComma = string.includes(',');
  const hasDot = string.includes('.');
  
  // Si tiene ambos, el último es el separador decimal
  if (hasComma && hasDot) {
    const lastCommaIndex = string.lastIndexOf(',');
    const lastDotIndex = string.lastIndexOf('.');
    
    if (lastCommaIndex > lastDotIndex) {
      // Formato europeo: 1.234,56
      return parseFloat(string.replaceAll('.', '').replace(',', '.'));
    } else {
      // Formato americano: 1,234.56
      return parseFloat(string.replaceAll(',', ''));
    }
  }
  
  // Si solo tiene coma, asumir formato europeo (coma decimal)
  if (hasComma && !hasDot) {
    return parseFloat(string.replace(',', '.'));
  }
  
  // Si solo tiene punto o ninguno, formato americano
  return parseFloat(string.replaceAll(',', ''));
};

export const prepareSalesCSV = (data) => {
  const result =
    !isEmpty(data) &&
    data.map((sale) => {
      const newData = {
        id: sale.id,
        created_at: moment(sale.created_at).format('DD/MM/YYYY hh:mm'),
        country_code: sale.country_code,
        item: sale.type,
        gross_income_value:
          sale.gross_income.amount / Math.pow(10, sale.gross_income.decimals),
        gross_income_currency: sale.gross_income.currency,
      };

      return newData;
    });
  return result;
};

export const prepareBalanceCSV = (data) => {
  return (
    !isEmpty(data) &&
    data.map((transaction) => {
      const newData = {
        id: transaction.id,
        created_at: moment(transaction.created_at).format('DD/MM/YYYY hh:mm'),
        item: transaction.type,
        net_income_value:
          transaction.net_income.amount /
          Math.pow(10, transaction.net_income.decimals),
        net_income_currency: transaction.net_income.currency,
      };
      return newData;
    })
  );
};

const currencySymbolMap = {
  AED: 'د.إ',
  AFN: '؋',
  ALL: 'L',
  AMD: '֏',
  ANG: 'ƒ',
  AOA: 'Kz',
  ARS: '$',
  AUD: '$',
  AWG: 'ƒ',
  AZN: '₼',
  BAM: 'KM',
  BBD: '$',
  BDT: '৳',
  BGN: 'лв',
  BHD: '.د.ب',
  BIF: 'FBu',
  BMD: '$',
  BND: '$',
  BOB: '$b',
  BOV: 'BOV',
  BRL: 'R$',
  BSD: '$',
  BTC: '₿',
  BTN: 'Nu.',
  BWP: 'P',
  BYN: 'Br',
  BYR: 'Br',
  BZD: 'BZ$',
  CAD: '$',
  CDF: 'FC',
  CHE: 'CHE',
  CHF: 'CHF',
  CHW: 'CHW',
  CLF: 'CLF',
  CLP: 'CLP',
  CNY: '¥',
  COP: '$',
  COU: 'COU',
  CRC: '₡',
  CUC: '$',
  CUP: '₱',
  CVE: '$',
  CZK: 'Kč',
  DJF: 'Fdj',
  DKK: 'kr',
  DOP: 'RD$',
  DZD: 'دج',
  EEK: 'kr',
  EGP: '£',
  ERN: 'Nfk',
  ETB: 'Br',
  ETH: 'Ξ',
  EUR: '€',
  FJD: '$',
  FKP: '£',
  GBP: '£',
  GEL: '₾',
  GGP: '£',
  GHC: '₵',
  GHS: 'GH₵',
  GIP: '£',
  GMD: 'D',
  GNF: 'FG',
  GTQ: 'Q',
  GYD: '$',
  HKD: '$',
  HNL: 'L',
  HRK: 'kn',
  HTG: 'G',
  HUF: 'Ft',
  IDR: 'Rp',
  ILS: '₪',
  IMP: '£',
  INR: '₹',
  IQD: 'ع.د',
  IRR: '﷼',
  ISK: 'kr',
  JEP: '£',
  JMD: 'J$',
  JOD: 'JD',
  JPY: '¥',
  KES: 'KSh',
  KGS: 'лв',
  KHR: '៛',
  KMF: 'CF',
  KPW: '₩',
  KRW: '₩',
  KWD: 'KD',
  KYD: '$',
  KZT: '₸',
  LAK: '₭',
  LBP: '£',
  LKR: '₨',
  LRD: '$',
  LSL: 'M',
  LTC: 'Ł',
  LTL: 'Lt',
  LVL: 'Ls',
  LYD: 'LD',
  MAD: 'MAD',
  MDL: 'lei',
  MGA: 'Ar',
  MKD: 'ден',
  MMK: 'K',
  MNT: '₮',
  MOP: 'MOP$',
  MRO: 'UM',
  MRU: 'UM',
  MUR: '₨',
  MVR: 'Rf',
  MWK: 'MK',
  MXN: 'MXN',
  MXV: 'MXV',
  MYR: 'RM',
  MZN: 'MT',
  NAD: '$',
  NGN: '₦',
  NIO: 'C$',
  NOK: 'kr',
  NPR: '₨',
  NZD: '$',
  OMR: '﷼',
  PAB: 'B/.',
  PEN: 'PEN',
  PGK: 'K',
  PHP: '₱',
  PKR: '₨',
  PLN: 'zł',
  PYG: 'Gs',
  QAR: '﷼',
  RMB: '￥',
  RON: 'lei',
  RSD: 'Дин.',
  RUB: '₽',
  RWF: 'R₣',
  SAR: '﷼',
  SBD: '$',
  SCR: '₨',
  SDG: 'ج.س.',
  SEK: 'kr',
  SGD: 'S$',
  SHP: '£',
  SLL: 'Le',
  SOS: 'S',
  SRD: '$',
  SSP: '£',
  STD: 'Db',
  STN: 'Db',
  SVC: '$',
  SYP: '£',
  SZL: 'E',
  THB: '฿',
  TJS: 'SM',
  TMT: 'T',
  TND: 'د.ت',
  TOP: 'T$',
  TRL: '₤',
  TRY: '₺',
  TTD: 'TT$',
  TVD: '$',
  TWD: 'NT$',
  TZS: 'TSh',
  UAH: '₴',
  UGX: 'USh',
  USD: '$',
  UYI: 'UYI',
  UYU: '$U',
  UYW: 'UYW',
  UZS: 'лв',
  VEF: 'Bs',
  VES: 'Bs.S',
  VND: '₫',
  VUV: 'VT',
  WST: 'WS$',
  XAF: 'FCFA',
  XBT: 'Ƀ',
  XCD: '$',
  XOF: 'CFA',
  XPF: '₣',
  XSU: 'Sucre',
  XUA: 'XUA',
  YER: '﷼',
  ZAR: 'R',
  ZMW: 'ZK',
  ZWD: 'Z$',
  ZWL: '$',
};

export const getSymbol = (currencyCode) => {
  if (typeof currencyCode !== 'string') {
    return undefined;
  }
  const code = currencyCode.toUpperCase();
  return currencySymbolMap[code] || currencyCode;
};

const dashboardUtils = {
  periodFilterValues,
  responsiveConfig,
  getSinceDate,
  prepareSalesCSV,
  prepareBalanceCSV,
  getSymbol,
  getColumnName,
  getItemName,
  formatNumber,
};

export default dashboardUtils;
